import Login from "./pages/Authentication/Login";
import Register from "./pages/Authentication/Register";
import ResetPassword from "./pages/CandidateAuthentication/ResetPassword";
import PasswordConfirm from "./pages/CandidateAuthentication/PasswordConfirm";
import UserResetPassword from "./pages/Authentication/UserResetPassword";
import UserPasswordConfirm from "./pages/Authentication/UserPasswordConfirm";
import Logout from "./pages/Authentication/Logout";

import CandidateForm from "./pages/Candidate/ApplicationView";
import CandidateLogin from "./pages/CandidateAuthentication/Login";
import CandidateHome from "./pages/CandidateDashboard/Home";
import Statistics from "./pages/Dashboard/Statistics";
import ApplicationBuilder from "./pages/Dashboard/ApplicationBuilder";
import ApplicationEditor from "./pages/Dashboard/ApplicationEditor";
import ApplicationList from "./pages/Dashboard/ApplicationList";
import Forms from "./pages/Dashboard/Forms";
import FormContacts from "./pages/Dashboard/FormContacts";
import questionBank from "./components/questionBank";
import ChatBotService from "./components/ChatbotService";
import Candidates from "./pages/Dashboard/Candidates";
import CandidatesNew from "./pages/Dashboard/CandidatesNew";
import CandidatesApproved from "./pages/Dashboard/CandidatesApproved";
import CandidatesArchive from "./pages/Dashboard/CandidatesArchive";
import CandidatesAssigned from "./pages/Dashboard/CandidatesAssigned";
import CandidatesRejected from "./pages/Dashboard/CandidatesRejected";
import CandidateSingle from "./pages/Dashboard/CandidateSingle";
import CandidateSingleEdit from "./pages/Dashboard/CandidateSingleEdit";
import Kanban from "./pages/Dashboard/Kanban";
import CandidateDashboard from "./pages/Candidate/CandidateDashboard";
import TalentRequisitionFormList from "./pages/Dashboard/TalentRequisitionFormList";
import TalentRequisitionForm from "./pages/Dashboard/TalentRequisitionForm";
import TalentRequisitionFormEdit from "./pages/Dashboard/TalentRequisitionFormEdit";
import TalentRequisitionFormView from "./pages/Dashboard/TalentRequisitionFormView";
import Users from "./pages/Dashboard/Users";
import SettingsAdmin from "./pages/Dashboard/SettingsAdmin";
import DocumentForms from "./pages/Dashboard/DocumentForms";
import DocumentFormsCreate from "./pages/Dashboard/DocumentFormsCreate";
import DocumentFormsEdit from "./pages/Dashboard/DocumentFormsEdit";
import FormsBulkUpload from "./pages/Dashboard/formsBulkUpload";
import Queries from "./pages/Dashboard/Queries";
import QueriesSingle from "./pages/Dashboard/QueriesSingle";
import QueriesUnsolved from "./pages/Dashboard/QueriesUnsolved";
import Process from "./pages/Dashboard/Process";
import Logs from "./pages/Dashboard/Logs";
import ReportsL1 from "./pages/Dashboard/Reports/L1";
import ReportsL2 from "./pages/Dashboard/Reports/L2";
import ReportsL3 from "./pages/Dashboard/Reports/L3";
import SubjectiveQuiz from "./pages/Candidate/SubjectiveQuiz";
import Instruction from "./pages/Candidate/Instruction";
import ThankYouPage from "./pages/Candidate/ThankYouPage";
import UpdateCandidate from "./pages/Candidate/UpdateCandidate";
import CandidateEdit from "./pages/Candidate/CandidateEdit";
import ValidateMobile from "./pages/Candidate/ValidateMobile";
import Form from "./pages/Candidate/Form";
import AddInterviewStatus from "./components/AddInterviewStatus";
import ClientMapping from "./components/ClientMapping";
import ConsultantMapping from "./components/ConsultantMapping";
import ClientDashboard from "./pages/ClientRound/ClientDashboard";
import UpcomingInterviewDetail from "./pages/ClientRound/UpcomingInterviewDetail";
import UpcomingInterviews from "./pages/ClientRound/UpcomingInterviews";
import CompletedInterviews from "./pages/ClientRound/CompletedInterviews";
import PendingInterviews from "./pages/ClientRound/PendingInterviews";
import ConsultantDashboard from "./pages/ConsultantDashboard/ConsultantDashboard";
import SelectedCandidates from "./pages/ConsultantDashboard/SelectedCandidates";
import NewCandidates from "./pages/ConsultantDashboard/NewCandidates";
import JoinedCandidates from "./pages/ConsultantDashboard/JoinedCandidates";
import PendingCandidates from "./pages/ConsultantDashboard/PendingCandidates";
import RejectedCandidates from "./pages/ConsultantDashboard/RejectedCandidates";
import QrCode from "./pages/ConsultantDashboard/QrCode";
import ConsultantLogin from "./pages/ConsultantAuthentication/ConsultantLogin";
import CallStatusMapping from "./components/CallStatusMapping";
import LogsStatus from "./reports/LogsStatus";
import InterviewLogs from "./reports/InterviewLogs";
import FeedbackReport from "./reports/FeedbackReport";
import InactiveCandidates from "./reports/InactiveCandidates";
import ThakYouFormSubmit from "./components/ThankYouFormSubmit";
import ViewApplication from "./pages/CandidateDashboard/ViewApplication";
import ViewDocuments from "./components/ViewDocuments";
import NotAuthorized from "./alert_pages/NotAuthorized";
import PageNotFound from "./alert_pages/PageNotFound";
import FeedbackAlreadySubmitAlert from "./alert_pages/FeedbackSubmitAlert";
import SubmitSuccess from "./alert_pages/SubmitSuccess";
import ErrorPage from "./alert_pages/ErrorPage";
import TinUpload from "./pages/Dashboard/TinManagement/TinUpload";
import TinUnFreeze from "./pages/Dashboard/TinManagement/TinUnFreeze";
import TinUploadReport from "./pages/Dashboard/TinManagement/TinUploadReport";
import TinUsageReport from "./pages/Dashboard/TinManagement/TinUsageReport";
import LoginReport from "./reports/LoginReport";
import CandidateList from "./pages/Documents/CandidateList";
import DocsVerify from "./pages/Documents/DocsVerify";
import TinRights from "./pages/Dashboard/TinRights";
import CreateDoc from "./pages/Documents/DigitalDocs/CreateDoc";
import ApiLogs from "./pages/Dashboard/ApiLogs";
import TrfProcess from "./pages/Dashboard/TrfProcess";
import ServiceSettings from "./pages/Dashboard/ServiceSettings";
import ActiveAndInactiveCandidates from "./reports/ActiveAndInactiveCandidate";
import TalentRequisitionAssign from "./pages/Dashboard/TalentRequisitionAssign";
import DocumentRepots from "./pages/Documents/DocumentReport";
import ViewDoc from "./pages/Documents/DigitalDocs/ViewDocs";
import AssignTrfReport from "./reports/AssignTrfReport";
import TrfReport from "./reports/TrfReport";
import GenerateXLSX from "./pages/Dashboard/GenerateXLSX";
import OpenResume from "./pages/Candidate/OpenResume";
import AllApplicationReport from "./reports/AllApplicationReport";
import InactiveCandidate from "./pages/ConsultantDashboard/InactiveCandidate";
import CompetencyConf from "./pages/competency/CompetencyConf";
import InterviewProcess from "./components/InterviewProcess";
import HRDashboard from "./pages/Analytics/HRDashboard";
import CentralHrDashboard from "./pages/makerchecker/CentralHr/CentralHrDashboard";
import CentralHrAuditPage from "./pages/makerchecker/CentralHr/CentralHrAuditPage";
import SiteHrDashboard from "./pages/makerchecker/SiteHr/SiteHrDashboard";
import SiteHrAuditPage from "./pages/makerchecker/SiteHr/SiteHrAuditPage";
import AuditReport from "./pages/makerchecker/report/AuditReport";
import UpdateCandidateForm from "./pages/CandidateDashboard/Home/CandidateEdit";
import OCRReport from "./reports/OCRReport";
import VoiceBotUpload from "./pages/Candidate/VoiceBotUpload";
import AIService from "./pages/Dashboard/AIService";
import AmeyoService from "./pages/Dashboard/AmeyoService";
import RecordAudio from "./pages/languageconfidence/RecordAudio";
import PhoneNumberInput from "./pages/languageconfidence/PhoneNumberInput.";
import GenerateQrCode from "./pages/Dashboard/GenerateQrCode";
import VersantConfig from "./pages/versantConfig/VersantConfig";
import Admin from "./pages/Admin/Admin";
import RuleEngineDashboard from "./pages/RukeEngine/RuleEngineDashboard";
import RuleEngineCreate from "./pages/RukeEngine/RuleEngineCreate";
import TransferLeads from "./pages/RukeEngine/TransferLeads";
import ManagerDashboard from "./pages/ManagerDashboard/ManagerDashboard";
import AmeyoConf from "./pages/Ameyo/AmeyoConf";

const routes = [
  {
    path: "/", //Done
    component: Login,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/login", //Done
    component: Login,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/logout",
    component: Logout,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/careers", //Done
    component: CandidateLogin,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/consultant", //Done
    component: ConsultantLogin,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/language-confidence", //Done
    component: PhoneNumberInput,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/language-confidence/test/:phone", //Done
    component: RecordAudio,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/update-candidate/:formId/:candidateId/:formType", //Done
    component: UpdateCandidateForm,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/userresetpassword", //Done
    component: UserResetPassword,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/user/resetPassword", //Done
    component: UserPasswordConfirm,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/resetpassword", //Done
    component: ResetPassword,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  // {
  //   path: "/candidate/resetPassword", //Done
  //   component: PasswordConfirm,
  //   logoutTime: false,
  //   isProtected: false,
  //   showSidebar: false,
  // },
  {
    path: "/voice-bot-upload", //Done
    component: VoiceBotUpload,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewVoiceBot",
  },
  {
    path: "/audit/central-hr", // Done
    component: CentralHrDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewCentralHRAudit",
  },
  {
    path: "/audit-report", //Done
    component: AuditReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAuditReport",
  },
  {
    path: "/audit/central-hr/document/:empId/:candidateId", //Done
    component: CentralHrAuditPage,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/audit/site-hr", //Done
    component: SiteHrDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewSiteHRAudit",
  },
  {
    path: "/audit/site-hr/document/:empId/:candidateId", //Done
    component: SiteHrAuditPage,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/analytics/:dashboardId", //Done
    component: HRDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAdminDashboard",
  },
  {
    path: "/interview/process/:designationId/:interviewId/:interviewNameId/:candidateId", //Done
    component: InterviewProcess,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/competency/configuration", //Done
    component: CompetencyConf,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewCompetencySetup",
  },
  {
    path: "/register", //Done
    component: Register,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/admin",
    component: Admin,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAdmin",
  },
  {
    path: "/careers/home", //Done
    component: CandidateHome,
    logoutTime: true,
    isProtected: true,
    type: "candidate",
    showSidebar: false,
  },
  {
    path: "/careers/view/:id", //Done
    component: ViewApplication,
    logoutTime: true,
    isProtected: true,
    type: "candidate",
    showSidebar: false,
  },
  {
    path: "/forms/:id", //Done
    component: CandidateForm,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/home", //Done
    component: Statistics,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAdminDashboard",
  },
  {
    path: "/application", //Done
    component: ApplicationList,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/form-templates", //Done
    component: Forms,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewForm",
  },
  {
    path: "/bulkUpload", //Done
    component: FormsBulkUpload,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewBulkUpload",
  },
  {
    path: "/build/forms", //Done
    component: ApplicationBuilder,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewFormBuilder",
  },
  {
    path: "/form-template/edit/:id", //Done
    component: ApplicationEditor,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/question/bank", //Done
    component: questionBank,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/chatbot/service", //Done
    component: ChatBotService,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/reports/l1", //Done
    component: ReportsL1,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/reports/l2", //Done
    component: ReportsL2,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/reports/l3", //Done
    component: ReportsL3,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidates/new", //Done
    component: CandidatesNew,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidates/approved", //Done
    component: CandidatesApproved,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidates/archive", //Done
    component: CandidatesArchive,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidates/assigned", //Done
    component: CandidatesAssigned,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidates/rejected", //Done
    component: CandidatesRejected,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidate/:id", //Done
    component: CandidateSingle,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidate/:id/edit", //Done
    component: CandidateSingleEdit,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/screening", //Done
    component: Kanban,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/trf_process", //Done
    component: TrfProcess,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/trf/create", //Done
    component: TalentRequisitionForm,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/trf/assign", //Done
    component: TalentRequisitionAssign,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAssignTrf",
  },
  {
    path: "/trf", //Done
    component: TalentRequisitionFormList,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewTrf",
  },
  {
    path: "/trf/:id/edit", //Done
    component: TalentRequisitionFormEdit,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/trf/:id/view", //Done
    component: TalentRequisitionFormView,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/users", //Done
    component: Users,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canManageUsers",
  },
  {
    path: "/documents", //Done
    component: DocumentForms,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/documents/create", //Done
    component: DocumentFormsCreate,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/documents/:id/edit", //Done
    component: DocumentFormsEdit,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/queries", //Done
    component: Queries,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/queries/unsolved", //Done
    component: QueriesUnsolved,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/queries/:id", //Done
    component: QueriesSingle,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/process", //Done
    component: Process,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/logs", //Done
    component: Logs,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewLogs",
  },
  {
    path: "/service/settings", //Done
    component: ServiceSettings,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewServiceSettings",
  },
  {
    path: "/ai/settings", //Done
    component: AIService,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAiService",
  },
  {
    path: "/ameyo/settings", //Done
    component: AmeyoService,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewAmeyoService",
  },
  {
    path: "/settings/admin", //Done
    component: SettingsAdmin,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewSettings",
  },
  {
    path: "/add/interviewStatus", //Done
    component: AddInterviewStatus,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewInterviewStatus",
  },
  {
    path: "/client/mapping", //Done
    component: ClientMapping,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewClientMapping",
  },
  {
    path: "/consultant/mapping", //Done
    component: ConsultantMapping,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewConsultantMapping",
  },
  {
    path: "/instruction/:id/:candidateId", //Done
    component: Instruction,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/candidate-update/:formId/:candidateId", //Done
    component: UpdateCandidate,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/edit/:id/:ids", //Done
    component: CandidateEdit,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/subjectiveQuestion/:id", //Done
    component: SubjectiveQuiz,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/Application-submitted/:formName", //Done
    component: ThankYouPage,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/thankyou/:id", //Done
    component: ThankYouPage,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/validatemobile/:id", //Done
    component: ValidateMobile,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/clientdashboard", //Done
    component: ClientDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/upcominginterviews", //Done
    component: UpcomingInterviews,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/upcominginterviewdetail", //Done
    component: UpcomingInterviewDetail,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/completedinterviews", //Done
    component: CompletedInterviews,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/consultantdashboard", //Done
    component: ConsultantDashboard,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/qrcode", //Done
    component: QrCode,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/selectedcandidates", //Done
    component: SelectedCandidates,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/newcandidates", //Done
    component: NewCandidates,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/joinedcandidates", //Done
    component: JoinedCandidates,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/pendingcandidates", //Done
    component: PendingCandidates,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/rejectedcandidates", //Done
    component: RejectedCandidates,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/inactivecandidate", //Done
    component: InactiveCandidate,
    logoutTime: true,
    isProtected: true,
    type: "consultant",
    showSidebar: true,
  },
  {
    path: "/call/status/mapping", //Done
    component: CallStatusMapping,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewCallStatus",
  },
  {
    path: "/pendinginterviews", //Done
    component: PendingInterviews,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/logs/ocr", //Done
    component: OCRReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/logs/status", //Done
    component: LogsStatus,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/logs/interview", //Done
    component: InterviewLogs,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewInterviewLogs",
  },
  {
    path: "/feedback/report", //Done
    component: FeedbackReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewFeedbackReport",
  },
  {
    path: "/api_logs", //Done
    component: ApiLogs,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewApiLogs",
  },
  {
    path: "/inactive/candidates", //Done
    component: InactiveCandidates,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/active_inactive/candidates", //Done
    component: ActiveAndInactiveCandidates,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/assigntrf/report", //Done
    component: AssignTrfReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewDistributedTrf",
  },
  {
    path: "/trf/report", //Done
    component: TrfReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/document_report", //Done
    component: DocumentRepots,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewDocumentReport",
  },
  {
    path: "/optional/test/form/:id/candidate/:cid",
    component: ThakYouFormSubmit,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/documents/view", //Done
    component: ViewDocuments,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewDocuments",
  },
  // {
  //   path: "/tin/upload", //Done
  //   component: TinUpload,
  //   logoutTime: true,
  //   isProtected: true,
  //   type: "user",
  //   showSidebar: true,
  // },
  // {
  //   path: "/tin/release", //Done
  //   component: TinUnFreeze,
  //   logoutTime: true,
  //   isProtected: true,
  //   type: "user",
  //   showSidebar: true,
  // },
  // {
  //   path: "/tin/uploaded/report", //Done
  //   component: TinUploadReport,
  //   logoutTime: true,
  //   isProtected: true,
  //   type: "user",
  //   showSidebar: true,
  // },
  {
    path: "/tin/usage/report", //Done
    component: TinUsageReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewTinReport",
  },
  {
    path: "/user/unauthorized", //Done
    component: NotAuthorized,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/login/report", //Done
    component: LoginReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewLoginReport",
  },
  {
    path: "/feedback/already-submitted", //Done
    component: FeedbackAlreadySubmitAlert,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/tin/rights", //Done
    component: TinRights,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/digital/document/create", //Done
    component: CreateDoc,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/digital/document/view/:id", //Done
    component: ViewDoc,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/documents/candidates", //Done
    component: CandidateList,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewDocuments",
  },
  {
    path: "/documents/verify/candidate/:id", //Done
    component: DocsVerify,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/submit/success", //Done
    component: SubmitSuccess,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  {
    path: "/generate-excel", //Done
    component: GenerateXLSX,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewGenerateExcel",
  },
  {
    path: "/generate-qrCode", //Done
    component: GenerateQrCode,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewQr",
  },
  {
    path: "/candidate_dashboard", //Done
    component: CandidateDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/all_applications_report", //Done
    component: AllApplicationReport,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewApplicationReport",
  },
  {
    path: "/doc/:path", //Done
    component: OpenResume,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/versant-configuration", //Done
    component: VersantConfig,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
    requiredPermission: "canViewVersant",
  },
  {
    path: "/rule-engine", //Done
    component: RuleEngineDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/rule-engine/create", //Done
    component: RuleEngineCreate,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/rule-engine/edit/:id", //Done
    component: RuleEngineCreate,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/rule-engine/clone/:clone", //Done
    component: RuleEngineCreate,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/rule-engine/transfer/:id", //Done
    component: TransferLeads,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/manager/dashboard", //Done
    component: ManagerDashboard,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/ameyo/configuration", //Done
    component: AmeyoConf,
    logoutTime: true,
    isProtected: true,
    type: "user",
    showSidebar: true,
  },
  {
    path: "/error/:id", //Done
    component: ErrorPage,
    logoutTime: false,
    isProtected: false,
    showSidebar: false,
  },
  { path: "*", component: PageNotFound, logoutTime: false, isProtected: false }, //Done,
];

export default routes;
